import { Grid, Paper, Tooltip } from '@mui/material';
import React from 'react';
import styles from './box-layout.styles';
import { Component } from 'react';
import { withStyles } from '@mui/styles';
import './index.css';
import { withTranslation } from 'react-i18next';

let nums = Array.from(Array(3).keys());
let nums1 = Array.from(Array(12).keys());
let elem = ['A', 'B', 'C'];
let deactivatedBin = [];
let IsSaved;
let BinIds = [];

export class Main22Layout extends Component {
    constructor(props) {
        super(props);
        this.state = {}
    }

    componentWillReceiveProps() {
        const { deactivatedBins } = this.props;
        if (deactivatedBins && deactivatedBins.length > 0) {
            deactivatedBins.map((item) => {
                return true
            })
        }
        else {
            deactivatedBin.map((item) => {
                return true
            })
            deactivatedBin = [];
        }
    }

    checkIsSaved = (binId) => {
        const { BinStatus } = this.props;
        if (BinStatus && BinStatus.length && BinStatus.length > 0) {
            BinStatus.map((binitem) => {
                if (binitem.bin_id === binId) {
                    IsSaved = true;
                }
                else {
                    IsSaved = false;
                }
                return true;
            })
        }
        else {
            IsSaved = false;
        }
    }

    openbin = (binId, status, pm_id) => {
        if (status === 'Assigned' || status === 'Stocked' || status === 'Hold') {
            if (this.props.deactivatedBins.includes(binId)) {
                this.props.Selectedbin(binId, this.props.box_position);
                let items = document.getElementById(binId);
                items.style.background = 'linear-gradient(155deg, rgb(253, 253, 252) 0%, rgb(249, 27, 27) 90%)'; // deavtivated
                items.style.color = '#ffffff'
            }
            this.props.getPrescriptionDetails(binId, pm_id);
        }
        else {
            BinIds.map((item) => {
                this.checkIsSaved(item);
                if (this.props.deactivatedBins.includes(item)) {
                    let items = document.getElementById(item);
                    items.style.background = 'linear-gradient(155deg, rgb(253, 253, 252) 0%, rgb(249, 27, 27) 90%)'; // deavtivated
                    items.style.color = '#ffffff'
                } else {
                    if (item !== binId && IsSaved === false) {
                        let items = document.getElementById(item);
                        items.style.background = 'linear-gradient(148deg, #ffffff 30%, #d9dcdb 60%, #dcdcdc 87%)'; // available
                    }
                }
                return true
            })
            BinIds = [];
            BinIds.push(binId);
            if (BinIds.length > 0) {
                this.props.Selectedbin(binId, this.props.box_position);
                var items = document.getElementById(binId);
                items.style.background = 'linear-gradient(155deg, rgb(253, 253, 252) 0%, rgb(253, 253, 2) 90%)'; // assigned
                if (this.props.deactivatedBins.includes(binId)) {
                    items.style.color = '#000000';
                }
            }
        }
    }

    render() {
        const BoxStatus = {
            ASSIGNED: '8f9c8e02-b9ee-4f29-aeea-670cef022663',
            STOCKED: '4ee90c0f-d4c3-4d53-8014-d7eac4ea2894',
            HOLD: '45593c2c-fc8c-4bf0-854e-e2bf759b7788',
            PICKED_UP: '00fe15e3-80b9-4e6f-9bf3-ad0c09a58c3e',
            CANCELLED: '8a994741-402e-4b18-a883-60da7fc94c7b',
            RETURNED: '198473ec-2e3f-42c8-a3f9-a0a3f8b4ae55',
            DEACTIVATED: '4f666da5-bfe0-4fb5-ad77-b92103881220'
        }
        const { classes, BinStatus, deactivatedBins, t, isViewPermissionAllowed } = this.props;
        return (
            <div key={this.props.prefix}>
                <div className={classes.ratingContainer}>
                    {nums1.map((n1) => {
                        return (
                            <Grid
                                key={n1}
                                container
                                direction="row"
                                justify="center"
                                alignItems="center"
                                spacing={8}
                                className={classes.RemoveMargin}
                                style={{ pointerEvents: isViewPermissionAllowed ? 'auto' : 'none' }}
                            >
                                {nums.map((n) => {
                                    if ((elem[n] === 'A' || elem[n] === 'B') && (n1 >= 0 && n1 <= 6)) {
                                        if (elem[n] === 'A') {
                                            return <Grid
                                                id={elem[n] + '' + (n1 + 1)}
                                                key={n}
                                                sx={{ cursor: 'pointer', p: '4px', width: '5rem' }}
                                                style={{ pointerEvents: isViewPermissionAllowed ? 'auto' : 'none' }}
                                            >
                                            </Grid>;
                                        } else {
                                            return <Grid
                                                id={elem[n] + '' + (n1 + 1)}
                                                key={n}
                                                sx={{ cursor: 'pointer', p: '4px', width: '6rem' }}
                                                style={{ pointerEvents: isViewPermissionAllowed ? 'auto' : 'none' }}
                                            >
                                            </Grid>;
                                        }
                                    } else {
                                        if (elem[n] === 'A' || elem[n] === 'B' || elem[n] === 'C') {
                                            if (BinStatus && BinStatus.length && BinStatus.length > 0) {
                                                let BinKey = elem[n] + (n1 + 1)
                                                for (var i = 0; i < BinStatus.length; i++) {
                                                    let pm_id = BinStatus[i].pm_id;
                                                    if (BinStatus[i].type_id === BoxStatus.STOCKED && BinStatus[i].bin_id === BinKey) {
                                                        if (deactivatedBins.includes(BinKey)) {
                                                            return (
                                                                <Tooltip key={((elem[n] + ' ' + (n1 + 1)))} title="DEACTIVATE">
                                                                    <Grid
                                                                        className={classes.kioskDoor}
                                                                        style={{ padding: '4px', pointerEvents: isViewPermissionAllowed ? 'auto' : 'none' }}
                                                                        onClick={() => this.openbin(elem[n] + '' + (n1 + 1), 'Stocked')}
                                                                        key={elem[n] + ' ' + (n1 + 1)} item xs={2}>
                                                                        <Paper id={elem[n] + '' + (n1 + 1)} className={classes.gridRedback}>
                                                                            {elem[n] + ' ' + (n1 + 1)}
                                                                        </Paper>
                                                                    </Grid>
                                                                </Tooltip>
                                                            );
                                                        } else {
                                                            return (
                                                                <Tooltip key={((elem[n] + ' ' + (n1 + 1)))} title={t("Global.Prescriptions.Status.Stocked")}>
                                                                    <Grid
                                                                        className={classes.kioskDoor}
                                                                        style={{ padding: '4px', pointerEvents: isViewPermissionAllowed ? 'auto' : 'none' }}
                                                                        onClick={() => this.openbin((elem[n] + '' + (n1 + 1)), 'Stocked', pm_id)}
                                                                        key={((elem[n] + ' ' + (n1 + 1)))} item xs={2}>
                                                                        <Paper id={elem[n] + '' + (n1 + 1)} className={classes.gridOrangeback}>
                                                                            {elem[n] + ' ' + (n1 + 1)}
                                                                        </Paper>
                                                                    </Grid>
                                                                </Tooltip>
                                                            );
                                                        }
                                                    }
                                                    else if (BinStatus[i].type_id === BoxStatus.ASSIGNED && BinStatus[i].bin_id === BinKey) {
                                                        if (deactivatedBins.includes(BinKey)) {
                                                            return (
                                                                <Tooltip key={((elem[n] + ' ' + (n1 + 1)))} title="DEACTIVATE">
                                                                    <Grid
                                                                        className={classes.kioskDoor}
                                                                        style={{ padding: '4px', pointerEvents: isViewPermissionAllowed ? 'auto' : 'none' }}
                                                                        onClick={() => this.openbin(elem[n] + '' + (n1 + 1), 'Assigned')}
                                                                        key={elem[n] + ' ' + (n1 + 1)} item xs={2}>
                                                                        <Paper id={elem[n] + '' + (n1 + 1)} className={classes.gridRedback}>
                                                                            {elem[n] + ' ' + (n1 + 1)}
                                                                        </Paper>
                                                                    </Grid>
                                                                </Tooltip>
                                                            );
                                                        } else {
                                                            return (
                                                                <Tooltip key={((elem[n] + ' ' + (n1 + 1)))} title={t("Global.Prescriptions.Status.Assigned")}>
                                                                    <Grid
                                                                        className={classes.kioskDoor}
                                                                        style={{ padding: '4px', pointerEvents: isViewPermissionAllowed ? 'auto' : 'none' }}
                                                                        onClick={() => this.openbin((elem[n] + '' + (n1 + 1)), 'Assigned', pm_id)}
                                                                        key={((elem[n] + ' ' + (n1 + 1)))} item xs={2}>
                                                                        <Paper id={elem[n] + '' + (n1 + 1)} className={classes.gridBlueback}>
                                                                            {elem[n] + ' ' + (n1 + 1)}
                                                                        </Paper>
                                                                    </Grid>
                                                                </Tooltip>
                                                            );
                                                        }
                                                    }
                                                    else if (BinStatus[i].type_id === BoxStatus.HOLD && BinStatus[i].bin_id === BinKey) {
                                                        if (deactivatedBins.includes(BinKey)) {
                                                            return (
                                                                <Tooltip key={((elem[n] + ' ' + (n1 + 1)))} title="DEACTIVATE">
                                                                    <Grid
                                                                        className={classes.kioskDoor}
                                                                        style={{ padding: '4px', pointerEvents: isViewPermissionAllowed ? 'auto' : 'none' }}
                                                                        onClick={() => this.openbin(elem[n] + '' + (n1 + 1), 'Hold')}
                                                                        key={elem[n] + ' ' + (n1 + 1)} item xs={2}>
                                                                        <Paper id={elem[n] + '' + (n1 + 1)} className={classes.gridRedback}>
                                                                            {elem[n] + ' ' + (n1 + 1)}
                                                                        </Paper>
                                                                    </Grid>
                                                                </Tooltip>
                                                            );
                                                        } else {
                                                            return (
                                                                <Tooltip key={((elem[n] + ' ' + (n1 + 1)))} title={t("Global.Prescriptions.Status.Hold")}>
                                                                    <Grid
                                                                        className={classes.kioskDoor}
                                                                        style={{ padding: '4px', pointerEvents: isViewPermissionAllowed ? 'auto' : 'none' }}
                                                                        onClick={() => this.openbin((elem[n] + '' + (n1 + 1)), 'Hold', pm_id)}
                                                                        key={((elem[n] + ' ' + (n1 + 1)))} item xs={2}>
                                                                        <Paper id={elem[n] + '' + (n1 + 1)} className={classes.gridSkyblueback}>
                                                                            {elem[n] + ' ' + (n1 + 1)}
                                                                        </Paper>
                                                                    </Grid>
                                                                </Tooltip>
                                                            );
                                                        }
                                                    }
                                                }
                                                if (deactivatedBins && deactivatedBins.length && deactivatedBins.length > 0 && deactivatedBins.findIndex(D => D === (elem[n] + (n1 + 1))) > -1) {
                                                    return (
                                                        <Tooltip key={((elem[n] + ' ' + (n1 + 1)))} title="DEACTIVATE">
                                                            <Grid
                                                                className={classes.kioskDoor}
                                                                style={{ padding: '4px', pointerEvents: isViewPermissionAllowed ? 'auto' : 'none' }}
                                                                onClick={() => this.openbin(elem[n] + '' + (n1 + 1))}
                                                                key={elem[n] + ' ' + (n1 + 1)} item xs={2}>
                                                                <Paper id={elem[n] + '' + (n1 + 1)} className={classes.gridRedback}>
                                                                    {elem[n] + ' ' + (n1 + 1)}
                                                                </Paper>
                                                            </Grid>
                                                        </Tooltip>
                                                    );
                                                } else {
                                                    return (
                                                        <Tooltip key={((elem[n] + ' ' + (n1 + 1)))} title={t("Global.Prescriptions.Status.Available")}>
                                                            <Grid
                                                                className={classes.kioskDoor}
                                                                style={{ padding: '4px', pointerEvents: isViewPermissionAllowed ? 'auto' : 'none' }}
                                                                onClick={() => this.openbin(elem[n] + '' + (n1 + 1))}
                                                                key={elem[n] + ' ' + (n1 + 1)} item xs={2}>
                                                                <Paper id={elem[n] + '' + (n1 + 1)} className={classes.gridback}>
                                                                    {elem[n] + ' ' + (n1 + 1)}
                                                                </Paper>
                                                            </Grid>
                                                        </Tooltip>
                                                    );
                                                }
                                            } else {
                                                if (deactivatedBins.length > 0 && deactivatedBins.findIndex(D => D === (elem[n] + (n1 + 1))) > -1) {
                                                    return (
                                                        <Tooltip key={((elem[n] + ' ' + (n1 + 1)))} title="DEACTIVATE">
                                                            <Grid
                                                                className={classes.kioskDoor}
                                                                style={{ padding: '4px', pointerEvents: isViewPermissionAllowed ? 'auto' : 'none' }}
                                                                onClick={() => this.openbin(elem[n] + '' + (n1 + 1))}
                                                                key={elem[n] + ' ' + (n1 + 1)} item xs={2}>
                                                                <Paper id={elem[n] + '' + (n1 + 1)} className={classes.gridRedback}>
                                                                    {elem[n] + ' ' + (n1 + 1)}
                                                                </Paper>
                                                            </Grid>
                                                        </Tooltip>
                                                    );
                                                } else {
                                                    return (
                                                        <Tooltip key={((elem[n] + ' ' + (n1 + 1)))} title={t("Global.Prescriptions.Status.Available")}>
                                                            <Grid
                                                                className={classes.kioskDoor}
                                                                style={{ padding: '4px', pointerEvents: isViewPermissionAllowed ? 'auto' : 'none' }}
                                                                onClick={() => this.openbin(elem[n] + '' + (n1 + 1))}
                                                                key={elem[n] + ' ' + (n1 + 1)} item xs={2}>
                                                                <Paper id={elem[n] + '' + (n1 + 1)} className={classes.gridback}>
                                                                    {elem[n] + ' ' + (n1 + 1)}
                                                                </Paper>
                                                            </Grid>
                                                        </Tooltip>
                                                    );
                                                }
                                            }
                                        }
                                    }
                                    return true
                                })
                                }
                            </Grid>
                        );
                    })}
                </div>
            </div>
        )
    }
};

export default withStyles(styles)(withTranslation()(Main22Layout));




// WEBPACK FOOTER //
// ./src/components/assign-prescriptions/Main22-layout.js